module.exports = __webpack_public_path__ + "img/a6f5043d586a15dc73eff5f316d4a1ec.png";